/* Packages */
import React, { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';
import useFlowContext from "conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext";

export default function ConversionFieldMoney(props) {
    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();

    const {
        translate = () => {},
    } = useFlowContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-label-group form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <NumberFormat
                    id={id}
                    className={`form-control ${error ? 'is-error' : ''}`}
                    placeholder={label}
                    name={id}
                    {...{
                        required,
                        disabled,
                        placeholder,
                    }}
                    value={value || ''}
                    onValueChange={({ floatValue }) => {
                        if (typeof floatValue !== 'undefined') {
                            updateValue(floatValue, () => {
                                trigger(path);
                            });
                        }
                    }}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    suffix=""
                    fixedDecimalScale={true}
                    decimalScale={0}
                />
                {label && (
                    <Form.Label className={'font-weight-light mt-0'} dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
